import { LoadableAfterPaint } from '@confluence/loadable';

export const AgentPresenceLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AgentPresence" */ '../src/AgentPresence/AgentPresence'
			)
		).AgentPresence,
});
